import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { Paper, Button } from '@mui/material';
import withRouter from '../hoc/withRouter';

class PayoneMock extends Component {
  finishPayment = () => {
    const { router } = this.props;
    const query = queryString.parse(router.location.search);
    window.location.href = `${query.successurl}`; // eslint-disable-line no-undef
  };

  render() {
    return (
      <Paper>
        <h1 className="mb0">Payment Mock</h1>
        <p>
          Click below to finish the payment
        </p>
        <Button
          onClick={this.finishPayment}
          primary="true"
        >
          Pay
        </Button>
      </Paper>
    );
  }
}

PayoneMock.propTypes = {
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(PayoneMock);
